import { PlaneView } from '../../view/views/PlaneView';

/**
 * Common base class for global coordinators
 * ({@link GlobalPanCoordinator}, {@link GlobalWindowingCoordinator})
 * that intercept mouse events in {@link ToolManager} before the
 * active tool.
 *
 * Captures the shared lifecycle contract and common state (views).
 * Subclass-specific mouse handling remains in each coordinator
 * because their parameter shapes differ significantly.
 */
export abstract class GlobalCoordinator {
    /** Available plane views (for cursor targeting). */
    protected views: PlaneView[] | undefined;

    /** Whether this coordinator is currently handling an action. */
    public abstract get isActive(): boolean;

    /** Cancel any active state and clean up. Called on mouse
     *  leave and during tool deactivation. */
    public abstract onMouseLeave(): void;
}
